import {getQuery} from "@/modules/common/utils";

const get = (params = {}) => {
  params.new_api = true
  return getQuery('/business/v1/audit_logs', params)
}

export const auditlogService = {
  get
}
